import Show from '../../../Show/Show';
import { FC } from 'react';
import { H3, ParagraphLRegular } from '../../../../config/designSystem/typography';
import { QuestionSessionBodyPresentationProps } from '../config';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { StyleWithBreakpoints, useBreakpointStyles } from '../../../../hooks/useBreakpointStyles';
import { View } from 'react-native';
import { observer } from 'mobx-react';

const _PresentDefault: FC<QuestionSessionBodyPresentationProps> = ({
  questionDescription,
  questionText,
}) => {
  const styles = useBreakpointStyles(breakpointStyles);
  return (
    <View style={styles.mainView}>
      <Show when={questionDescription}>
        <View style={styles.contentView}>
          <ParagraphLRegular selectable={true}>
            {questionDescription}
          </ParagraphLRegular>
        </View>
      </Show>
      <Show when={questionText}>
        <View style={styles.contentView}>
          <H3 selectable={true}>
            {questionText}
          </H3>
        </View>
      </Show>
    </View>
  );
};
const breakpointStyles = {
  mainView: {
    marginHorizontal: SPACING['sp-16'],
    md: {
      marginHorizontal: SPACING['sp-126'],
    },
    lg: {
      marginHorizontal: SPACING['sp-200'],
    },
    xl: {
      marginHorizontal: SPACING['sp-200'],
    }
  },
  contentView: {
    marginBottom: 32,
    marginTop: 8,
    alignContent: 'center',
    alignItems: 'center'
  }
} satisfies Record<string, StyleWithBreakpoints>;

export const PresentDefault = observer(_PresentDefault);
